const PlanMainText = ({ text }) => {
  return <div className={'mb-2 plan-main-text'}>{text}</div>;
};

export default PlanMainText;
